import { 
  FieldType, 
  FieldOptions, 
  TextareaOptions, 
  HeaderOptions, 
  SelectOptions, 
  CheckboxWithInputOptions, 
  LogicOptions, 
  MultiRowOptions,
  ImageOptions 
} from './form';

// Type guards for field options
export const isTextareaOptions = (options: FieldOptions): options is TextareaOptions => {
  return typeof options === 'object' && 'rows' in options;
};

export const isHeaderOptions = (options: FieldOptions): options is HeaderOptions => {
  return typeof options === 'object' && 'fontSize' in options;
};

export const isSelectOptions = (options: FieldOptions): options is SelectOptions => {
  return typeof options === 'object' && 
    !('rows' in options) && 
    !('fontSize' in options) && 
    !('inputType' in options) && 
    !('logicType' in options) && 
    !('columns' in options);
};

export const isCheckboxWithInputOptions = (options: FieldOptions): options is CheckboxWithInputOptions => {
  return typeof options === 'object' && 'inputType' in options;
};

export const isLogicOptions = (options: FieldOptions): options is LogicOptions => {
  return typeof options === 'object' && 'logicType' in options;
};

export const isMultiRowOptions = (options: FieldOptions): options is MultiRowOptions => {
  return typeof options === 'object' && 'columns' in options;
};

export const isImageOptions = (options: FieldOptions): options is ImageOptions => {
  return typeof options === 'object' && 
    ('layout' in options || 
     'aboveTitle' in options || 
     'showBorder' in options || 
     'imageSize' in options || 
     'imageSource' in options);
};

// Type guards for field types
export const isSelectFieldType = (fieldType: FieldType): boolean => {
  return ['dropdown', 'checkbox', 'radio'].includes(fieldType);
};

export const isInputFieldType = (fieldType: FieldType): boolean => {
  return ['text', 'number', 'phone', 'email', 'date'].includes(fieldType);
};

export const hasPlaceholder = (fieldType: FieldType): boolean => {
  return !['multi_row', 'header', 'checkbox_with_input', 'checkbox', 'radio'].includes(fieldType);
};

// API Response type guards
export interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const isPaginatedResponse = <T>(data: any): data is PaginatedResponse<T> => {
  return data && 
    typeof data === 'object' && 
    'results' in data && 
    Array.isArray(data.results) &&
    'count' in data &&
    typeof data.count === 'number';
};

export const isDirectArray = <T>(data: any): data is T[] => {
  return Array.isArray(data);
};